import { createContext, useContext } from "react";

import type { WorkspaceDetailed } from "./api";

export interface ActiveWorkspaceContextValue {
    activeWorkspaceId: string | null;
    activeWorkspace: WorkspaceDetailed | null;
    workspaces: WorkspaceDetailed[];
    setActive: (workspaceId: string) => void;
    isLoading: boolean;
    isError: boolean;
}

export const ActiveWorkspaceContext = createContext<ActiveWorkspaceContextValue | null>(null);

export function useActiveWorkspace(): ActiveWorkspaceContextValue {
    const ctx = useContext(ActiveWorkspaceContext);
    if (!ctx) {
        throw new Error("useActiveWorkspace must be used within ActiveWorkspaceProvider");
    }
    return ctx;
}
